import { ProductVisualizationResultMessageType } from "@redotech/redo-model/conversation/message-parsers/product-visualization-result-message-parser";
import { memo, useState } from "react";
import { Flex } from "../../flex";
import { Text } from "../../text";
import { ImageLightbox } from "./image-lightbox";

export interface ProductVisualizationResultProps {
  message: ProductVisualizationResultMessageType;
  readOnly?: boolean;
}

export const ProductVisualizationResult = memo(
  function ProductVisualizationResult({
    message,
    readOnly,
  }: ProductVisualizationResultProps) {
    const visualizationUrl = message.structuredContent?.visualizationUrl;
    const [open, setOpen] = useState(false);

    if (!visualizationUrl) {
      return null;
    }

    return (
      <>
        <Flex align="flex-start" dir="column" w="full">
          <Flex dir="column" gap="xs" style={{ maxWidth: "280px" }}>
            <img
              alt="Product visualization"
              onClick={() => setOpen(true)}
              src={visualizationUrl}
              style={{
                width: "100%",
                height: "auto",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                cursor: "zoom-in",
              }}
            />
            <Text fontSize="xs" textColor="tertiary">
              AI-generated • Results may vary
            </Text>
          </Flex>
        </Flex>
        {open && (
          <ImageLightbox
            altText="Product visualization (full size)"
            imageUrl={visualizationUrl}
            onClose={() => setOpen(false)}
          />
        )}
      </>
    );
  },
);
